module.exports = __webpack_public_path__ + "static/monei_team-b580b07c46e0b2c2432e6ac3f015100b.jpeg";